// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vNf02KNFtF7x2axDruL0{padding:0 7px}`, "",{"version":3,"sources":["webpack://./src/widgets/MessageField/ui/SwitchMode/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,aAAA","sourcesContent":[".wrap {\n  padding: 0 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `vNf02KNFtF7x2axDruL0`
};
export default ___CSS_LOADER_EXPORT___;
